var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c(
        "div",
        {
          staticClass: "btn-close",
          on: {
            click: function($event) {
              return _vm.$emit("closeModal")
            }
          }
        },
        [
          _c("v-img", {
            attrs: { src: require("@/assets/icons/clear_icon.svg") }
          })
        ],
        1
      ),
      _c(
        "keep-alive",
        [
          _c(_vm.editarusuario, {
            tag: "component",
            attrs: {
              tipoAtivo: _vm.currentPropertie,
              userToEdit: _vm.userToEditar,
              botaoSalvarAlteracoesUsuario:
                _vm.botaoSalvarAlteracoesUsuarioClicado
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "btn-cadastrar-usuario" },
        [
          _c(
            "v-btn",
            {
              attrs: {
                large: "",
                rounded: "",
                color: "primary",
                loading: _vm.loading
              },
              on: {
                click: function($event) {
                  return _vm.$emit("execUpdateUser")
                }
              }
            },
            [
              _c(
                "p",
                { staticStyle: { color: "white", "margin-bottom": "0px" } },
                [_vm._v("Salvar alterações")]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [
        _vm._v("Editar "),
        _c("span", { staticStyle: { color: "var(--principal-azul)" } }, [
          _vm._v("Usuário")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }